import React from 'react'
import ReactDOM from 'react-dom'
import App from './containers/BriefSearch'

ReactDOM.render(<App />, document.getElementById('app'))
